<template>
  <b-row>
    <b-col>
      <b-row class="mb-50">
        <b-col>
          <div style="display: flex;justify-content: center;">
            <h4>Índice geral de cobranças</h4>
            <div style="padding-left: 0.4rem">
              <i
                v-b-tooltip.hover
                title="Consolidação de documentos cobrados até a data atual de todas as equipes."
                style="font-size: 0.85rem;"
                class="question-icon"
              >
                <font-awesome-icon
                  :icon="faQuestionCircle"
                />
              </i>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row
        align-h="between"
        class="mb-3"
        style="align-items: center;"
      >
        <b-col cols="6">
          <span>Total geral: {{ totalDocumentosFormatado }} [100%]</span>
        </b-col>
        <b-col cols="auto">
          <flat-pickr
            v-model="competencia"
            class="form-control"
            :config="options"
            @on-change="filtrarDocumentos"
          />
        </b-col>
      </b-row>
      <b-row v-if="carregado">
        <b-col
          v-for="(documento, $index) in statusDocumentos"
          :key="$index"
          cols="2"
        >
          <div class="shadow-box">
            <div style="text-align: center;padding-top: 0.5rem;">
              <div>
                <strong>{{ documento.statusDocumento }}</strong>
              </div>
              <div style="margin-top: 0.3rem">
                <span>{{ documento.numeroDocumentos }}</span>
              </div>
            </div>
            <dashboard-totalizador
              :valor="[documento.porcentagemDocumentos]"
              :cores="[documento.color]"
            />
            <div
              class="cor-fundo"
              :style="`background-color: ${documento.color};`"
            />
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<style lang="scss">
.cor-fundo {
  margin-top: 0.5rem;
  height: 7px;
  border-bottom-right-radius: 0.428rem;
  border-bottom-left-radius: 0.428rem;
}

.shadow-box {
  box-shadow: 1px 2px 5px 4px rgb(20 20 20 / 40%);
  border-radius: 0.428rem;
}

.container-class {
  width: 100%;
  display: table-cell;
  padding-left: 0.5rem;
}
</style>

<script>
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import flatPickr from 'vue-flatpickr-component'
import api from '@/app-modulo/documento/dashboard-cobranca/shared/services/api'

export default {
  name: 'TotalizadorDocumentos',
  components: {
    flatPickr,
    FontAwesomeIcon,
    dashboardTotalizador: () => import('@/shared/components/grafico-totalizador/GraficoTotalizador.vue'),
  },
  data() {
    return {
      statusDocumentos: null,
      carregado: false,
      faQuestionCircle,
      totalDocumentos: 0,
      competencia: [],
      options: {
        mode: 'range',
        dateFormat: 'm/Y',
        // eslint-disable-next-line global-require
        locale: require('flatpickr/dist/l10n/pt').default.pt,
      },
      now: new Date(),
      datasFiltro: [],
    }
  },
  computed: {
    totalDocumentosFormatado() {
      return this.totalDocumentos.toLocaleString('pt-BR')
    },
  },
  created() {
    this.competencia.push(new Date(this.now.getFullYear(), this.now.getMonth() - 1))
    this.datasFiltro.push(moment(new Date(this.now.getFullYear(), this.now.getMonth() - 1)).format('DD/MM/YYYY'))
    this.carregarDados()
  },
  methods: {
    carregarDados() {
      api.getTotalDocumentos(this.datasFiltro)
        .then(payload => {
          this.statusDocumentos = payload.data
          this.totalDocumentos = payload.data.reduce((soma, item) => soma + item.totalDocumentos, 0)
          this.carregado = true
        })
    },
    filtrarDocumentos(selectedDates, dateStr) {
      if (selectedDates && selectedDates.length === 2) {
        this.datasFiltro = []
        this.datasFiltro = dateStr.split(' até ')
        this.carregarDados()
      }
    },
  },
}
</script>
